import _ from 'lodash';
import { createSelector } from 'reselect';
import moment from 'moment';

export const minDateForActiveOrders = moment().subtract(14, 'd');

export const getShippingOrders = state => state.customer.profile.shippingOrders.ordersList;
export const getActiveShippingOrder = state => state.customer.profile.shippingOrders.activeOrder;
export const getPreviousShippingOrder = state => state.customer.profile.shippingOrders.previousOrder;
export const getSelectedTabName = state => state.customer.profile.shippingOrders.selectedTabName;
export const isLoading = state => state.customer.profile.shippingOrders.isLoading;

export const getActiveShippingOrdersList = orders => _.filter(orders, order => (!moment(order.createDateTime, 'YYYY-MM-DD').isBefore(minDateForActiveOrders)));
export const getPreviousShippingOrdersList = orders => _.filter(orders, order => (moment(order.createDateTime, 'YYYY-MM-DD').isBefore(minDateForActiveOrders)));

export const getNewestShippingOrder = state => _.find(state.customer.profile.shippingOrders.ordersList, order => _.min(order.createDateTime));